export default __webpack_public_path__ + "assets/profeature-card-fixed.295b2b2ed6c932ee37bc4dd5085bdc0e.jpg";